import(/* webpackMode: "eager" */ "/var/www/lumi/apps/studio/src/app/login/page.tsx");
